import React, { useState, useEffect } from "react";
import { translations, type Language, type TranslationKey } from "./translations";
import { TranslationContext } from "./translation-context";

export function TranslationProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguage] = useState<Language>(() => {
    if (typeof window === "undefined") return "de";
    const saved = localStorage.getItem("cr_lang") as Language;
    return saved && translations[saved] ? saved : "de";
  });

  useEffect(() => {
    localStorage.setItem("cr_lang", language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key: TranslationKey): string => {
    const v = translations[language][key];
    return v ?? key;
  };

  return (
    <TranslationContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </TranslationContext.Provider>
  );
}
